import React from 'react'
import { DatePicker } from 'antd'
import type { CustomDateProps } from 'ag-grid-react'
import dayjs from 'dayjs'

/**
 * Custom Date Component for AG Grid Date Filter
 * Uses Ant Design DatePicker with Finnish date format (DD.MM.YYYY)
 */
const DateColumnFilter: React.FC<CustomDateProps> = ({ date, onDateChange }) => {
  const handleChange = (value: dayjs.Dayjs | null) => {
    onDateChange(value?.toDate() ?? null)
  }

  return (
    <DatePicker
      value={date ? dayjs(date) : null}
      onChange={handleChange}
      format="DD.MM.YYYY"
      placeholder="Valitse päivä"
      style={{ width: '100%' }}
      allowClear
      getPopupContainer={() => document.body}
      classNames={{ popup: { root: 'ag-custom-component-popup' } }}
    />
  )
}

export default DateColumnFilter
